import { useParams, useNavigate } from "react-router-dom";
import HelpSignupLogin from "./HelpSignupLogin";
import HelpUserVerification from "./HelpUserVerification";
import HelpUserRegistration from "./HelpUserRegistration";
import HelpAddressRegistration from "./HelpAddressRegistration";
import HelpKYC from "./HelpKYC";
import HelpWalletCreation from "./HelpWalletCreation";
import HelpNodeCardScreen from "./HelpNodeCardScreen";
import HelpCardPurchase from "./HelpCardPurchase";
import HelpCardRegister from "./HelpCardRegister";
import HelpCardTopup from "./HelpCardTopup";
import HelpPinSetup from "./HelpPinSetup";
import HelpCardStatus from "./HelpCardStatus";
import HelpStolenCard from "./HelpStolenCard";
import HelpCardHistory from "./HelpCardHistory";
import HelpProfile from "./HelpProfile";
import HelpPasswordChange from "./HelpPasswordChange";

export default function HelpDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Map help topic IDs to their respective components
  const helpComponents = {
    1: HelpSignupLogin,
    2: HelpUserVerification,
    3: HelpUserRegistration,
    4: HelpAddressRegistration,
    5: HelpKYC,
    6: HelpWalletCreation,
    7: HelpNodeCardScreen,
    8: HelpCardPurchase,
    9: HelpCardRegister,
    10: HelpCardTopup,
    11: HelpPinSetup,
    12: HelpCardStatus,
    13: HelpStolenCard,
    14: HelpCardHistory,
    15: HelpProfile,
    16: HelpPasswordChange,
  };

  const HelpComponent = helpComponents[id];

  if (!HelpComponent) {
    // If invalid ID, redirect back to help page
    navigate("/help");
    return null;
  }

  return <HelpComponent />;
}
